import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const ServiceCard = ({ s, flip }) => (
  <Reveal>
    <article data-testid={`service-card-${s.id}`} className="group grid items-center gap-10 border-t border-white/10 py-14 lg:grid-cols-12 lg:gap-16 lg:py-20">
      <div className={`lg:col-span-6 ${flip ? "lg:order-2" : ""}`}>
        <motion.div initial="hide" whileInView="show" viewport={{ once: true, amount: 0.1 }} className="relative aspect-[4/3] overflow-hidden rounded-[2px]">
          <motion.img
            src={s.img}
            alt={s.title}
            variants={{ hide: { clipPath: "inset(0 0 100% 0)" }, show: { clipPath: "inset(0 0 0% 0)" } }}
            transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
            className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
          />
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,transparent_30%,rgba(14,20,32,0.55)_100%)]" />
          <span className="absolute left-5 top-4 font-display text-6xl italic text-[#f4f1ea]/90">{s.n}</span>
        </motion.div>
      </div>
      <div className="lg:col-span-6">
        <h3 className="font-display text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">{s.title}</h3>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-[#f4f1ea]/70 md:text-lg">{s.body}</p>
        <ul className="mt-10 divide-y divide-white/10 border-y border-white/10">
          {s.bullets.map((b, i) => (
            <li key={b} className="flex items-center gap-5 py-4 text-sm transition-[padding,color] duration-300 hover:pl-3 hover:text-[var(--gold)] md:text-base">
              <span className="font-mono text-xs text-[var(--gold)]">0{i + 1}</span>{b}
            </li>
          ))}
        </ul>
      </div>
    </article>
  </Reveal>
);

export const Services = ({ t }) => (
  <section id="services" data-testid="services-section" className="grain relative bg-[var(--ink)] py-24 text-[var(--ivory)] lg:py-36">
    <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal><p className="label !text-[var(--gold)]">{t.services.label}</p></Reveal>
      <Reveal delay={0.05}>
        <h2 data-testid="services-title" className="mt-8 max-w-3xl font-display text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-7xl">{t.services.title}</h2>
      </Reveal>
      <div className="mt-16">
        {t.services.items.map((s, i) => <ServiceCard key={s.id} s={s} flip={i % 2 === 1} />)}
      </div>
    </div>
  </section>
);
